import React from 'react';
import { Col } from '@cvent/carina/components/Col';
import { Row } from '@cvent/carina/components/Row';

import { FooterLinks } from '@components/textFields/FooterLinks';
import { RegionMenu } from '@components/menus/RegionMenu';
import { LanguageMenu } from '@components/menus/LanguageMenu';
import { useFooterStyle } from '@hooks/style/useFooterStyle';
import { FlexType, PaddingType } from '@cvent/carina/components/Col/Col.style';

type FooterContainerProps = {
  testID: string;
};
export const FooterContainer = ({ testID }: FooterContainerProps): JSX.Element => {
  const { bottomColFlex, bottomColPadding, leftColPadding, leftColFlex, rightColPadding, rightColFlex } =
    useFooterStyle();
  const footerLeftCol = {
    s: { width: 1 },
    m: { width: 256 },
    l: { width: 256 },
    xl: { width: 256 }
  };
  const footerRightCol = {
    s: { width: 1 },
    m: { width: 200 },
    l: { width: 200 },
    xl: { width: 200 }
  };
  const footerBottomCol = {
    s: { width: 1 },
    m: { width: 200 },
    l: { width: 200 },
    xl: { width: 200 }
  };
  return (
    <div role={'complementary'}>
      <Row justifyContent={'center'} testID={`${testID}_footer__top_row`}>
        <Col
          {...footerLeftCol}
          flex={leftColFlex as FlexType}
          padding={leftColPadding as PaddingType}
          testID={`${testID}_footer__top_left_col`}
        >
          <RegionMenu testID={testID} />
        </Col>
        <Col
          {...footerRightCol}
          flex={rightColFlex as FlexType}
          padding={rightColPadding as PaddingType}
          testID={`${testID}_footer__top_right_col`}
        >
          <LanguageMenu testID={testID} />
        </Col>
      </Row>
      <Row justifyContent={'center'} testID={`${testID}_footer__bottom_row`}>
        <Col
          {...footerBottomCol}
          flex={bottomColFlex as FlexType}
          padding={bottomColPadding as PaddingType}
          testID={`${testID}_footer__bottom_col`}
        >
          <FooterLinks testID={testID} />
        </Col>
      </Row>
    </div>
  );
};
